import { Injectable } from '@angular/core';
import { WidgetViewDefinition, WidgetFilterViewDefinition } from './definitions';
import { DashboardCustomizationConst } from './DashboardCustomizationConsts';
import { WidgetDailySalesComponent } from './widgets/widget-daily-sales/widget-daily-sales.component';
import { WidgetProfitShareComponent } from './widgets/widget-profit-share/widget-profit-share.component';
import { WidgetMemberActivityComponent } from './widgets/widget-member-activity/widget-member-activity.component';
import { WidgetSalesSummaryComponent } from './widgets/widget-sales-summary/widget-sales-summary.component';
import { WidgetIncomeStatisticsComponent } from './widgets/widget-income-statistics/widget-income-statistics.component';
import { WidgetRecentTenantsComponent } from './widgets/widget-recent-tenants/widget-recent-tenants.component';
import { WidgetEditionStatisticsComponent } from './widgets/widget-edition-statistics/widget-edition-statistics.component';
import { WidgetSubscriptionExpiringTenantsComponent } from './widgets/widget-subscription-expiring-tenants/widget-subscription-expiring-tenants.component';
import { WidgetHostTopStatsComponent } from './widgets/widget-host-top-stats/widget-host-top-stats.component';
import { FilterDateRangePickerComponent } from './filters/filter-date-range-picker/filter-date-range-picker.component';
import { UserInfosectionComponent } from '../../../main/new-dashboard/Shared/user-infosection/user-infosection.component';
import { DashboardTimesheetComponent } from '../../../main/new-dashboard/Shared/dashboard-timesheet/dashboard-timesheet.component';
import { DashboardProductivityInfoSectionComponent } from '../../../main/new-dashboard/Shared/dashboard-productivity-info-section/dashboard-productivity-info-section.component';
import { TaskListComponent } from '../../../main/new-dashboard/Shared/task-list/task-list.component';
import { UserTimecardsinfoComponent } from '../../../main/new-dashboard/Shared/user-timecardsinfo/user-timecardsinfo.component';
import { DashboardProjectSectionComponent } from '../../../main/new-dashboard/Shared/dashboard-project-section/dashboard-project-section.component';
import { DashboardProductiveappsComponent } from '../../../main/new-dashboard/Shared/dashboard-productiveapps/dashboard-productiveapps.component';
import { DashboardUnproductiveappsComponent } from '../../../main/new-dashboard/Shared/dashboard-unproductiveapps/dashboard-unproductiveapps.component';
import { DashboardNeutralappsComponent } from '../../../main/new-dashboard/Shared/dashboard-neutralapps/dashboard-neutralapps.component';
import { TeamMemberSectionComponent } from '../../../main/new-dashboard/Shared/team-member-section/team-member-section.component';
import { TeamDetailsSectionComponent } from '../../../main/new-dashboard/Shared/team-details-section/team-details-section.component';
import { LeaveReportInfoComponent } from '../../../main/new-dashboard/Shared/leave-report-info/leave-report-info.component';
import { TeamdashboardCardSectionComponent } from '../../../main/new-dashboard/Shared/teamdashboard-card-section/teamdashboard-card-section.component';
import { NewJoineeSectionComponent } from '../../../main/new-dashboard/Shared/new-joinee-section/new-joinee-section.component';
import { ProjectsInfoSectionComponent } from '../../../main/new-dashboard/Shared/projects-info-section/projects-info-section.component';
import { LeaveRequestComponent } from '../../../main/new-dashboard/Shared/leave-request/leave-request.component';
import { DashboardTimesheetRequestComponent } from '../../../main/new-dashboard/Shared/dashboard-timesheet-request/dashboard-timesheet-request.component';
import { ProductivityBarComponent } from '../../../main/new-dashboard/Shared/productivity-bar/productivity-bar.component';
import { BillableEmployeeComponent } from '../../../main/new-dashboard/Shared/billable-employee/billable-employee.component';

@Injectable({
    providedIn: 'root'
})
export class DashboardViewConfigurationService {
    public WidgetViewDefinitions: WidgetViewDefinition[] = [];
    public widgetFilterDefinitions: WidgetFilterViewDefinition[] = [];

    constructor(
    ) {
        this.initializeConfiguration();
    }

    private initializeConfiguration() {

        let filterDateRangePicker = new WidgetFilterViewDefinition(
            DashboardCustomizationConst.filters.filterDateRangePicker,
            FilterDateRangePickerComponent
        );
        //add your filters here
        this.widgetFilterDefinitions.push(filterDateRangePicker);

        let generalStats = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.generalStats,
            ProductivityBarComponent,
        );

        let dailySales = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.dailySales,
            WidgetDailySalesComponent,
        );

        let profitShare = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.profitShare,
            WidgetProfitShareComponent
        );

        let memberActivity = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.memberActivity,
            WidgetMemberActivityComponent,
        );

        let salesSummary = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.salesSummary,
            WidgetSalesSummaryComponent,
        );

        let topStats = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.topStats,
            UserInfosectionComponent,
        );
        //add your tenant side widgets here

        let incomeStatistics = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.host.incomeStatistics,
            WidgetIncomeStatisticsComponent,
        );

        let editionStatistics = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.host.editionStatistics,
            WidgetEditionStatisticsComponent,
        );

        let recentTenants = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.host.recentTenants,
            WidgetRecentTenantsComponent,
        );

        let subscriptionExpiringTenants = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.host.subscriptionExpiringTenants,
            WidgetSubscriptionExpiringTenantsComponent
        );

        let hostTopStats = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.host.topStats,
            WidgetHostTopStatsComponent,
        );

        let timesheetTab = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.timeSheetTab,
            DashboardTimesheetComponent,
        );

        let ArrivalInfo = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.ArrivalInfo,
            UserTimecardsinfoComponent,
        )

        let ProjectInfoTab = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.ProjectInfoTab,
            DashboardProjectSectionComponent,
        )

        let ProductiveAppsSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.ProductiveAppsSection,
            DashboardProductiveappsComponent,
        )

        let UnProductiveAppsSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.UnProductiveAppsSection,
            DashboardUnproductiveappsComponent,
        )

        let NeutralAppsSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.NeutralAppsSection,
            DashboardNeutralappsComponent,
        )

        let OrgUnit = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.OrgUnit,
            TeamMemberSectionComponent,
        )

        let LeaveReports = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.LeaveReports,
            LeaveReportInfoComponent,
        )

        let SecondTabProjectsCountInfo = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabProjectsCountInfo,
            TeamdashboardCardSectionComponent,
        )

        let SecondTabEmployeeSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabEmployeeSection,
            BillableEmployeeComponent,
        )
        let SecondTabNewJoinerSections = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabNewJoinerSections,
            NewJoineeSectionComponent,
        )

        let SecondTabProjectSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabProjectSection,
            ProjectsInfoSectionComponent,
        )

        let SecondTabLeaveReports = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabLeaveReports,
            LeaveRequestComponent,
        )

        let SecondTabTeamTimesheetSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabTeamTimesheetSection,
            DashboardTimesheetRequestComponent,
        )

        let SecondTabTeamDetailsSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.SecondTabTeamDetailsSection,
            TeamDetailsSectionComponent
        )

        let TaskListSection = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.TaskListSection,
            TaskListComponent,
        )

        let ProductivityChartInfo = new WidgetViewDefinition(
            DashboardCustomizationConst.widgets.tenant.ProductivityChartInfo,
            DashboardProductivityInfoSectionComponent,
        )

        //add your host side widgets here

        this.WidgetViewDefinitions.push(generalStats);
        this.WidgetViewDefinitions.push(dailySales);
        this.WidgetViewDefinitions.push(profitShare);
        this.WidgetViewDefinitions.push(memberActivity);
        this.WidgetViewDefinitions.push(salesSummary);
        this.WidgetViewDefinitions.push(topStats);
        this.WidgetViewDefinitions.push(incomeStatistics);
        this.WidgetViewDefinitions.push(editionStatistics);
        this.WidgetViewDefinitions.push(recentTenants);
        this.WidgetViewDefinitions.push(subscriptionExpiringTenants);
        this.WidgetViewDefinitions.push(hostTopStats);
        this.WidgetViewDefinitions.push(timesheetTab);
        this.WidgetViewDefinitions.push(ArrivalInfo);
        this.WidgetViewDefinitions.push(ProjectInfoTab);
        this.WidgetViewDefinitions.push(ProductiveAppsSection);
        this.WidgetViewDefinitions.push(UnProductiveAppsSection);
        this.WidgetViewDefinitions.push(NeutralAppsSection);
        this.WidgetViewDefinitions.push(OrgUnit);
        this.WidgetViewDefinitions.push(LeaveReports);
        this.WidgetViewDefinitions.push(TaskListSection);
        this.WidgetViewDefinitions.push(ProductivityChartInfo);
        this.WidgetViewDefinitions.push(SecondTabProjectsCountInfo);
        this.WidgetViewDefinitions.push(SecondTabEmployeeSection);
        this.WidgetViewDefinitions.push(SecondTabNewJoinerSections);
        this.WidgetViewDefinitions.push(SecondTabProjectSection);
        this.WidgetViewDefinitions.push(SecondTabLeaveReports);
        this.WidgetViewDefinitions.push(SecondTabTeamTimesheetSection);
        this.WidgetViewDefinitions.push(SecondTabTeamDetailsSection);
    }
    }
